import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import DrawerCopy from '../copy/getDrawerData';
import MobileCopy from '../copy/Mobile';
import UserLinkCopy from '../copy/getUserLinks';
import { usabillaLink, getWufooURL } from '../../../helpers/languageHelpers';
import { createURLHelper } from '../components/Drawer/getDrawerData';
import { getHelpCenterLink } from '../../../helpers/getHelpLink';
export var enterprise = function enterprise() {
  return {
    title: t(DrawerCopy.ENTERPRISE),
    subTitle: t(DrawerCopy.ENTERPRISE_SUBTITLE),
    url: createURL('/mp/enterprise/', createURLHelper('enterprise', '7MQAU', 'Enterprise', 'SME', 'SME'))
  };
};
export var audience = function audience() {
  return {
    title: t(DrawerCopy.AUDIENCE),
    subTitle: t(DrawerCopy.AUDIENCE_SUBTITLE),
    url: createURL('/market-research/solutions/audience-panel/', {
      ut_source: 'header_products_launchpad_audience'
    })
  };
};
export var integrations = function integrations() {
  return {
    title: t(DrawerCopy.INTEGRATIONS_AND_PLUGINS),
    subTitle: t(DrawerCopy.INTEGRATIONS_AND_PLUGINS_SUBTITLE),
    url: createURL('/apps/', createURLHelper('integrations', '7RQAU', 'Enterprise', 'Salesforce', 'SME'))
  };
};
export var cx = function cx() {
  return {
    title: 'CX',
    subTitle: 'Understand & improve customer experience (NPS®)',
    url: createURL('https://www.surveymonkey.com/cx/', createURLHelper('cx', '7bQAE', 'Solutions', 'CX', 'CX'))
  };
};
export var engage = function engage() {
  return {
    title: 'Engage',
    subTitle: 'Understand & increase employee engagement',
    url: createURL('https://www.surveymonkey.com/engage/', createURLHelper('engage', '7vQAE', 'Solutions', 'Engage', 'Engage'))
  };
};
export var techValidate = function techValidate() {
  return {
    title: 'TechValidate',
    subTitle: 'Create marketing content from customer feedback',
    url: createURL('https://www.surveymonkey.com/techvalidate/', createURLHelper('techvalidate', '880QAE', 'Solutions', 'TV', 'TV'))
  };
};
export var wufoo = function wufoo(lang) {
  return {
    title: 'Wufoo',
    subTitle: t(DrawerCopy.WUFOO_SUBTITLE),
    url: createURL(getWufooURL(lang), {
      ut_source: 'header_products_launchpad_wufoo'
    })
  };
};
export var apply = function apply() {
  return {
    title: 'Apply',
    subTitle: t(DrawerCopy.APPLY_SUBTITLE),
    url: createURL('https://apply.surveymonkey.com/', {
      ut_source: 'header_products_launchpad_apply',
      program: '7013A000000mY8AQAU'
    })
  };
};
export var usabilla = function usabilla(lang) {
  return {
    title: 'Usabilla',
    subTitle: t(DrawerCopy.USABILLA_SUBTITLE),
    url: createURL(usabillaLink(lang), {
      utm_source: 'header_products_launchpad'
    })
  };
};
export var getFeedback = function getFeedback() {
  return {
    title: 'GetFeedback',
    subTitle: 'Customer feedback for Salesforce',
    url: createURL('https://www.getfeedback.com/', {
      utm_source: 'surveymonkey'
    }),
    openInNewWindow: true
  };
};
export var helpCenter = function helpCenter(lang) {
  return {
    title: t(DrawerCopy.HELP_CENTER),
    subTitle: t(DrawerCopy.HELP_CENTER_SUBTITLE),
    url: getHelpCenterLink(lang, {
      params: {
        ut_source: 'header'
      }
    })
  };
};
export var blog = function blog() {
  return {
    title: t(DrawerCopy.SURVEYMONKEY_BLOG),
    subTitle: t(DrawerCopy.SURVEYMONKEY_BLOG_SUBTITLE),
    url: createURL('/curiosity/', {
      ut_source: 'header'
    })
  };
};
export var products = function products() {
  return {
    title: t(MobileCopy.PRODUCTS)
  };
};
export var help = function help() {
  return {
    title: t(MobileCopy.HELP)
  };
};
export var myAccount = function myAccount() {
  return {
    url: createURL('/user/account/', {
      ut_source: 'header'
    }),
    title: t(UserLinkCopy.MY_ACCOUNT)
  };
};
export var switchAccount = function switchAccount() {
  return {
    url: createURL('/user/account/select/', {
      ut_source: 'header',
      ep: window && "".concat(window.location.pathname).concat(window.location.search)
    }),
    title: t(UserLinkCopy.SWITCH_ACCOUNTS)
  };
};
export var team = function team() {
  return {
    url: createURL('/team', {
      ut_source: 'header'
    }),
    title: t(UserLinkCopy.MY_TEAM)
  };
};
export var library = function library() {
  return {
    url: createURL('/team/libraries', {
      ut_source: 'header'
    }),
    title: t(UserLinkCopy.LIBRARY)
  };
};
export var contacts = function contacts() {
  return {
    url: createURL('/addressbook/', {
      ut_source: 'header'
    }),
    title: t(UserLinkCopy.CONTACTS)
  };
};
export var benchmark = function benchmark() {
  return {
    url: createURL('/benchmarks/home/', {
      ut_source: 'header_username_menu',
      ut_source2: 'wide_menu'
    }),
    title: t(UserLinkCopy.BENCHMARKS)
  };
};
export var signOut = function signOut() {
  return {
    url: createURL('/user/sign-out/', {
      ut_source: 'header'
    }),
    title: t(UserLinkCopy.SIGN_OUT)
  };
};
//# sourceMappingURL=MobileLinkInfo.js.map